import { formatDate } from '@angular/common';
import { DateTime } from 'luxon';

export const formatTimestamp = (timestamp?: string): string => {
  if (!timestamp) return 'N/A';
  try {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) {
      console.warn('Invalid date format received:', timestamp);
      return 'N/A';
    }
    return formatDate(date, 'HH:mm - dd/MM/yy', 'en');
  } catch (error) {
    console.warn('Invalid date format:', timestamp);
    return 'N/A';
  }
};

export const formatRelativeTimestamp = (
  timestamp?: string,
  locale = 'en',
): string => {
  if (!timestamp) return 'N/A';

  const date = DateTime.fromISO(timestamp).setLocale(locale);
  if (!date.isValid) return 'N/A';

  return date.toRelative() ?? formatTimestamp(timestamp);
};

export function buildTimestamp(): string {
  const d = new Date();
  return (
    `${d.getFullYear()}-` +
    `${String(d.getMonth() + 1).padStart(2, '0')}-` +
    `${String(d.getDate()).padStart(2, '0')}_` +
    `${String(d.getHours()).padStart(2, '0')}-` +
    `${String(d.getMinutes()).padStart(2, '0')}-` +
    `${String(d.getSeconds()).padStart(2, '0')}`
  );
}
